import React, { useState } from 'react';

import { TextField } from '@gerdau/hefesto';

import TextTooltipInformation from './TextTooltipInformation';
import {
  Container,
  OrderNameWrapper,
  OrderDetailsValuesContainer,
  OrderItemWrapper,
  ItemText,
  OrderValuesContainer,
  Divider
} from './styles';

interface OrderItemProps {
  title: string;
  value: string;
  tooltipText?: string;
  placement?: 'bottomLeft' | 'topLeft';
}

interface CheckoutOrderProps {
  orderDetails: OrderItemProps[];
  orderValues: OrderItemProps[];
  orderTax: OrderItemProps[];
  updateCustomerId: (customerId: string) => void;
}

const OrderItemTitle = ({
  title,
  tooltipText,
  placement
}: Pick<OrderItemProps, 'title' | 'tooltipText' | 'placement'>) => {
  if (tooltipText) {
    return (
      <TextTooltipInformation title={tooltipText} placement={placement}>
        <ItemText bold>{title}</ItemText>
      </TextTooltipInformation>
    );
  }

  return <ItemText bold>{title}</ItemText>;
};

export const OrderItem = ({
  title,
  value,
  tooltipText,
  placement
}: OrderItemProps) => {
  return (
    <OrderItemWrapper>
      <OrderItemTitle {...{ title, tooltipText, placement }} />
      <ItemText>{value}</ItemText>
    </OrderItemWrapper>
  );
};

const OrderDetails = ({
  details,
  updateCustomerId
}: {
  details: OrderItemProps[];
  updateCustomerId: (param: string) => void;
}) => {
  const [purchaseNumbeState, setPurchaseNumbeState] = useState('');
  const minLength = 3;
  const updateCustomerPurchaseId = () => {
    if (purchaseNumbeState.length >= minLength) {
      updateCustomerId(purchaseNumbeState);
    }
  };

  const onChangeOrderNumber = (value: string) => {
    if (/^[a-zA-Z0-9--]*$/.test(value)) {
      setPurchaseNumbeState(value.slice(0, 34).trim());
    }
  };

  return (
    <div>
      <ItemText isTitle>Detalhes do pedido</ItemText>

      <OrderNameWrapper>
        <TextField
          label={'Identificação do pedido'}
          name={'orderName'}
          placeholder="Insira um nome para o seu pedido"
          value={purchaseNumbeState}
          onChange={(e) => onChangeOrderNumber(e.target.value)}
          onBlur={updateCustomerPurchaseId}
          helperText="Informação adicional e opcional para ajudá-lo a identificar pedido dentre os demais."
          supportMessage="Mínimo de três caracteres."
          variant={
            !purchaseNumbeState.length || purchaseNumbeState.length >= minLength
              ? undefined
              : 'danger'
          }
          helperTextTooltipPlacement="bottomLeft"
          maxLength={34}
        />
      </OrderNameWrapper>
      <OrderDetailsValuesContainer smallerMarginTop={false}>
        {details.map((detail) => (
          <OrderItem key={detail.title} {...detail} />
        ))}
      </OrderDetailsValuesContainer>
    </div>
  );
};

const OrderValues = ({
  values,
  taxs
}: {
  values: OrderItemProps[];
  taxs: OrderItemProps[];
}) => {
  return (
    <OrderValuesContainer>
      <ItemText isTitle>Valores do pedido</ItemText>
      <OrderDetailsValuesContainer smallerMarginTop={false}>
        {values.map((detail) => (
          <OrderItem
            key={detail.title}
            {...{
              ...detail
            }}
          />
        ))}
      </OrderDetailsValuesContainer>
      <Divider />
      <ItemText>
        Valores de impostos inclusos no preço total do pedido.
      </ItemText>
      <OrderDetailsValuesContainer smallerMarginTop={true}>
        {taxs.map((detail) => (
          <OrderItem key={detail.title} {...{ ...detail }} />
        ))}
      </OrderDetailsValuesContainer>
    </OrderValuesContainer>
  );
};

const CheckoutOrder = ({
  orderDetails,
  orderValues,
  orderTax,
  updateCustomerId
}: CheckoutOrderProps) => {
  return (
    <Container>
      <OrderDetails
        details={orderDetails}
        updateCustomerId={updateCustomerId}
      />
      <OrderValues values={orderValues} taxs={orderTax} />
    </Container>
  );
};

export default CheckoutOrder;
